import { BrowserModule } from '@angular/platform-browser'
import { NgModule } from '@angular/core'
import { HttpClientModule } from '@angular/common/http'
import { ClarityModule } from '@clr/angular'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { AppRoutingModule } from './app-routing.module'
import { AppComponent } from './app.component'
import { MICROSOFT_SIGN_IN_INITIALIZER } from './auth/microsoft-sign-in.initializer'
import { GraphQLModule } from './core/graphql/graphql.module'
import { HomeModule } from './home/home.module'
import { LoginModule } from './login/login.module'
import { CoreModule } from './core/core.module'

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    GraphQLModule,
    HttpClientModule,
    ClarityModule,
    BrowserAnimationsModule,
    HomeModule,
    LoginModule,
    CoreModule,
  ],
  providers: [MICROSOFT_SIGN_IN_INITIALIZER],
  bootstrap: [AppComponent],
})
export class AppModule {}
